import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          //header
          home: "HOME", 
          about: "ABOUT", 
          rooms: "ROOMS", 
          amenities: "AMENITIES", 
          gallery: "GALLERY", 
          contact: "CONTACT",
          book_now: "Book Now",
          
          //footer
          cham_hotel: "Cham Hotel",
          damascus_heritage: "Damascus Heritage",
          footer_text1:"Experience the timeless elegance of Damascus in our luxury heritage hotel.",
          quick_links:"Quick Links",
          services:"Services",
          follow_us: "Follow Us",
          footer_text2: "Stay connected for exclusive offers and updates.",
          right_reserved: "Cham Hotel Damascus. All Rights Reserved.",
          privacy_policy: "Privacy Policy",
          terms_of_service:"Terms Of Service",

          //home
          legacy_of_hospitality: "A Legacy of Hospitality",
          learn_more_history: "Learn More About Our History",
          luxury_amenities: "Luxury Amenities",
          amenities_description: "Indulge in our world-class facilities designed to provide the ultimate comfort and relaxation.",
          room_suites: "Rooms & Suites",
          rooms_description:"Choose from our elegantly appointed accommodations, each designed to reflect the rich heritage of Damascus.",
          request_booking: "Request Booking",
          photo_gallery: "Photo Gallery",
          gallery_description:"Discover the beauty and elegance of our heritage hotel through these stunning visuals.",
          guest_testimonials: "Guest Testimonials",
          testimonial_description: "Hear What out distinguished guests have to say about their experience at Cham Hotel.",

          //contatc
          Contact: "Contact",
          us: "Us",
          contact_description:"Get in touch with us to plan your perfect stay in Damascus.",
          address: "Address",
          phone: "Phone",
          email: "Email",
          contact_text1: "Send Us a Message",
          contact_text2: "We'll get back to you within 24 hours",
          full_name: "Full Name",
          full_name_is_required: "Full name is required",
          phone_is_required: "Phone is required",
          email_is_required: "Email is required",
          subject: "Subject",
          subject_is_required: "Subject is required",
          message: "Message",
          message_is_required: "Message is required",
          send_message: "SEND MESSAGE",

          //popup
          name: "Name",
          start_date: "Start Date",
          end_date: "End Date",
          members_count: "Members Count",
          choose_room_categories: "Choose Room Categories",
          choose_room_type: "Choose Room Type",
          room_deluxe: "Room Deluxe",
          room_standard: "Room Standard",
          room_executive: "Room Executive",
          business_suite: "Business Suite",
          junior_suite: "Junior Suite",
          la_suite: "La Suite",
          presidential_suite: "Presidential Suite",
          imperial_suite: "Imperial Suite",
          the_request_sent_successfully: "The Request Sent Successfully",
          the_request_failed: "The Request Failed",
        }
      },
      ar: {
        translation: {
          //header
          home: "الصفحة الرئيسية",
          about: "من نحن",
          rooms: "الغرف",
          amenities: "الخدمات",
          gallery: "المعرض",
          contact: "اتصل بنا",
          book_now: "احجز الآن",


          //footer
          cham_hotel: "فندق شام",
          damascus_heritage: "تراث دمشق",
          footer_text1:"استمتع بالأناقة الخالدة لمدينة دمشق في فندقنا التراثي الفاخر.",
          quick_links:"روابط سريعة",
          services: "الخدمات",
          follow_us: "تابعنا على : ",
          footer_text2: "ابقى على اتصال للحصول على العروض الحصرية والتحديثات.",
          right_reserved: "فندق شام، دمشق. جميع الحقوق محفوظة.",
          privacy_policy: "سياسة الخصوصية",
          terms_of_service:"شروط الخدمة",


          //home
          legacy_of_hospitality: "تراث من الضيافة",
          learn_more_history: "تعرف على المزيد عن تاريخنا",
          luxury_amenities: "المرافق الفاخرة",
          amenities_description: "استمتع بمرافقنا العالمية المصممة لتوفير أقصى درجات الراحة والاسترخاء.",
          room_suites: "الغرف و الأجنحة",
          rooms_description: "يمكنك الاختيار من بين أماكن الإقامة المجهزة بأناقة، والتي تم تصميم كل منها لتعكس التراث الغني لمدينة دمشق.",
          request_booking: "طلب الحجز",
          photo_gallery: "صور المعرض",
          gallery_description: "اكتشف جمال وأناقة فندقنا التراثي من خلال هذه الصور المذهلة",
          guest_testimonials: "آراء الضيوف",
          testimonial_description: "استمع إلى ما يقوله ضيوفنا المميزون عن تجربتهم في فندق شام.",

          //contact
          Contact: "اتصل",
          us: "بنا",
          contact_description: "تواصل معنا للتخطيط لإقامتك المثالية في دمشق.",
          address: "العنوان",
          phone: "الهاتف",
          email: "الإيميل",
          contact_text1: "أرسل لنا رسالة",
          contact_text2: "سوف نتواصل معك خلال 24 ساعة",
          full_name: "الأسم الكامل",
          full_name_is_required: "الاسم الكامل مطلوب",
          phone_is_required: "الهاتف مطلوب",
          email_is_required: "البريد الالكتروني مطلوب",
          subject: "الموضوع",
          subject_is_required: "الموضوع مطلوب",
          message: "الرسالة",
          message_is_required: "الرسالة مطلوبة",
          send_message: "إرسال رسالة",

          //popup
          name: "الاسم",
          start_date: "تاريخ البدء",
          end_date: "تاريخ الانتهاء",
          members_count: "عدد الأشخاص",
          choose_room_categories: "اختر تصنيفات الغرف",
          choose_room_type: "اختر نوع الغرفة",
          room_deluxe: "غرفة ديلوكس",
          room_standard: "غرفة ستاندر",
          room_executive: "غرفة تنفيذية",
          business_suite: "جناح الاعمال",
          junior_suite: "الجناح الصغير",
          la_suite: "لا سويت",
          presidential_suite: "الجناج الرئيسي",
          imperial_suite: "الجناح الامبراطوري",
          the_request_sent_successfully: "تم ارسال الطلب بنجاح",
          the_request_failed: "لم يتم ارسال الرسالة",
        }
      }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
